module.exports = __webpack_public_path__ + "static/media/leading-mental-health@2x.9e84848b.png";